<template>
    <div   v-on:keyup.esc="close" >
        <b-modal :active.sync="isComponentModalActive"
                 :full-screen.sync="isFullScreen"
                 has-modal-card  >

            <div class="modal-card ">
                <header class="modal-card-head"  >

                    <section class="modal-card-body  "  >
                        <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
                        <HeaderDecorate :showLabNo=true :idlab="IDLABSelected.idlab" />
                    </section>

                </header>



                <section class="modal-card-body"  >

<!--   {{dataPCRSpecLN}}-->
<!--                    <hr>-->
<!--   {{dataPCRSpecLN.dataresultset_1}}-->
<!--                    <hr>-->
<!--   {{dataPCRSpecLN.dataresultset_2}}-->
<!--                    <hr>-->

<!--                   <p> userRoleFind  </p>     {{userRoleFind(4)}}-->
<!--                    <hr>-->
<!--                    <p> dataPCRSpecLN.status.id  </p>   {{ dataPCRSpecLN.status.id}}-->


                    <DetailUsedPartFromRequestDataEachLab
                            :IDLABSelected ="IDLABSelected"/>

                    <!--               Head     -->
                    <nav class="level is-mobile">
                        <div class="level-left">
                            <div class="level-item">
                                <p class="is-size-5"> Status </p>
                            </div>
                            <div class="level-item">
                                <p v-if="dataPCRSpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataPCRSpecLN.status.name }}  </p>
                                <p v-if="dataPCRSpecLN.status.id >=5 && dataPCRSpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataPCRSpecLN.status.name }}  </p>
                                <p v-if="dataPCRSpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataPCRSpecLN.status.name }} </p>
                            </div>
                            <div class="level-item">
                                <b-icon icon="lock" type="is-danger"  v-if="dataPCRSpecLN.status.id >=5 "  ></b-icon>
                                <b-icon icon="lock-open" type="is-success"  v-if="dataPCRSpecLN.status.id < 5 "  ></b-icon>
                            </div>
                            <div class="level-item">
                                <p class="is-size-5"> Assigned for </p>
                            </div>
                            <div class="level-item">
                                <p class="is-size-5 has-text-black"> &nbsp; {{ dataPCRSpecLN.assigned_to_user.name }}</p>
                            </div>
                            <div class="level-item" v-if="userIsAdmin && dataPCRSpecLN.status.id !== 7 ">
                                <b-button size="is-medium"
                                          icon-left="minus-circle"  >
                                    Disable
                                </b-button>
                            </div>
                        </div>
                    </nav>

<!--           Main PCR data         -->


                 <div class="box">
                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <h1 class="title" style="color: #167df0">
                                        <b-icon  icon="file-document"  size="is-small"></b-icon>
                                        {{headerInfoPrepare}}
                                    </h1>
                                </div>


                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <p class="is-size-6 has-text-grey"> My Templates </p>
                                </div>
                                <div class="level-item">
                                    <b-select placeholder="Template" v-model="dataTemplateSelectedPrepare"
                                              :disabled="!(userRoleFind(3) &&dataPCRSpecLN.status.id <5)">
                                        <option
                                                v-for="dataTemplate in myTemplate"
                                                :value="dataTemplate.id"
                                                :key="dataTemplate.id">
                                            {{ dataTemplate.title }}
                                        </option>
                                    </b-select>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success"
                                              icon-right="plus"
                                              @click="addTemplate('editorDat_prepare')"
                                              :disabled="!(userRoleFind(3) &&dataPCRSpecLN.status.id <5)"/>
                                </div>
                            </div>
                        </nav>
                        <hr>
                        <vue-editor v-model="buffDatPrepareDatModel "
                                     id="editorDat_prepare"
                                    :editor-toolbar="customToolbar"
                                    :disabled="!(userRoleFind(3) && dataPCRSpecLN.status.id <5 )"
                                    ref="editorDat_prepare"
                        />
                 </div>


                    <br>

<!--   Pathogen     -->
                     <div class="box">
                         <nav class="level">
                             <h1 class="title" style="color: #167df0">
                                 <b-icon  icon="dna"  size="is-small"></b-icon>
                                 {{resultPCRTitle}}
                             </h1>
                         </nav>
                         <nav class="level is-mobile">
                             <div class="level-left">

                                 <div class="level-item">
                                     <b-button type="is-success"
                                               icon-left="plus-box"
                                               :disabled="!((userRoleFind(4)  )&& dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id)" @click="addPathogen">
                                         Add
                                     </b-button>
                                 </div>

                             </div>
                             <div class="level-right">


                             </div>
                         </nav>



                         <div class="box">
<!--                             {{dataPathogenSpecForVisibleTrue}}-->
<!--                             <hr>-->

<!-- dataPCRSpecLN.dataresultset_2-->
                             <b-table
                                     :data=" dataPathogenSpecForVisibleTrue"
                                     :bordered=false
                                     :striped=false
                                     narrowed
                                     :hoverable=false
                                     :focusable=false
                                      mobile-cards>


                                 <b-table-column   label="Pathogen"   v-slot="props">

                                     <h3 class="subtitle is-5"> {{ props.row.title }}</h3>
                                 </b-table-column>




                                 <b-table-column   label="Result"   >
                                     <template v-slot:header="{ column }">
                                             {{ column.label }}
                                         <span class="has-text-danger">*</span>
                                     </template>
                                     <template v-slot="props">
                                         <b-select placeholder="Select a result"
                                                   v-model="props.row.result_dat"
                                                   :disabled="!((userRoleFind(4)  )&&dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id)"  >
                                             <option
                                                     v-for="result_aval in props.row.result_aval"
                                                     :value="result_aval"
                                                     :key="result_aval">
                                                 {{ result_aval }}
                                             </option>
                                         </b-select>
                                     </template>


                                 </b-table-column>

                                 <b-table-column   label="Remark"  v-slot="props">


                                     <b-field  :type="{ 'is-danger':   props.row.comment_each.length>GLOBAL_VAR.MAX_CHAR_PCR_COMMENT_EACH  }"
                                               :message= "{ 'Max Over range' :   props.row.comment_each.length>GLOBAL_VAR.MAX_CHAR_PCR_COMMENT_EACH   }"  expanded>
                                         <b-input v-model="props.row.comment_each"
                                                  :disabled="!((userRoleFind(4)  )&&dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id)"
                                                    >{{ props.row.comment_each }} </b-input>
                                         <template slot="message">
                                              <span class="has-text-primary is-italic" v-if="props.row.comment_each">({{props.row.comment_each.length}}/{{GLOBAL_VAR.MAX_CHAR_PCR_COMMENT_EACH}})</span>
                                         </template>
                                     </b-field>


                                 </b-table-column>


                                 <b-table-column   label="#"  v-slot="props">
                                          <b-button type="is-danger"
                                                    icon-left="delete"
                                                    :disabled="!((userRoleFind(4)  )&&dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id)"
                                          @click="deleteItemPathogen( props.row.idpathogen)">
                                              Delete
                                          </b-button>
                                 </b-table-column>
                             </b-table>

                         </div>



                     </div>
                     <br>


 <!-------------          findinds and contents       -->
                    <div class="box">
                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <h1 class="title" style="color: #167df0">
                                        <b-icon  icon="file-document"  size="is-small"></b-icon>
                                        {{findingAndContent}}
                                    </h1>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <p class="is-size-6 has-text-grey"> My Templates </p>
                                </div>
                                <div class="level-item">

                                    <b-select placeholder="Template" v-model="dataTemplateSelectedCt"  :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id)">
                                        <option
                                                v-for="dataTemplate in myTemplate"
                                                :value="dataTemplate.id"
                                                :key="dataTemplate.id">
                                            {{ dataTemplate.title }}
                                        </option>
                                    </b-select>


                                </div>
                                <div class="level-item">
                                    <b-button type="is-success"
                                              icon-right="plus"
                                              @click="addTemplate('editorDat_ct')"
                                              :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id)"/>
                                </div>

                            </div>
                        </nav>
                        <hr>
                        <vue-editor v-model="buffDatCtDatModel"
                                    id="editorDat_ct"
                                    :editor-toolbar="customToolbar"
                                    :disabled="!(userRoleFind(3) && dataPCRSpecLN.status.id <5 )"
                                    ref="editorDat_ct"
                        />
                    </div>

<!--          images  -->
                    <div class="box">
                        <nav class="level">
                            <h1 class="title" style="color: #167df0">
                                <b-icon  icon="camera-image"  size="is-small"></b-icon>
                                Add Images
                            </h1>
                        </nav>
                        <nav class="level">
                            <b-tooltip label="Attach Image"  position="is-right">
                                <b-button
                                        icon-right="paperclip"
                                        type="is-success"
                                        @click="addImageAttach"
                                        :disabled="!((userRoleFind(4)  )&&dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id)">Add Images</b-button>
                            </b-tooltip>
                        </nav>
                        <hr>
                        <ThumbnailImageList  :modeThumbnailImageList="modeThumbnailImageList" v-if="dataPCRSpecLN.img.dat.length>0"
                                             :dataPassThruImageList="dataPassThruImageList"
                                             @deleteImage="deleteImage" />
                        <hr  v-if="dataPCRSpecLN.img.dat.length>0">
                        <br>
                    </div>



<!--         Dx Code  -->
               <div class="box">
                    <nav class="level">
                        <h1 class="title" style="color: #167df0"> <b-icon
                                icon="codepen"
                                size="is-small">
                        </b-icon>  Classification of Diseases</h1>
                    </nav>
                    <nav class="level">
                        <b-tooltip label="Add More Disease Code"  position="is-right">
                            <b-button
                                    type="is-success"
                                    icon-right="plus"
                                    @click="addNewDiseaseCode"
                                    :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id)"
                            />

                        </b-tooltip>
                    </nav>
                    <br>

                    <b-table
                            :data="isEmpty ? [] : dataPCRSpecLN.diag_code.dat"
                            bordered
                            striped
                            narrowed
                            hoverable
                            focusable
                            mobile-cards>


                        <b-table-column   label="Chapter"  v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>
                        <b-table-column   label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>
                        <b-table-column   label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>
                        <b-table-column   label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>
                        <b-table-column   label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>
                        <b-table-column   label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>

                        <b-table-column   label="Unclassified Descriptions" v-slot="props" >
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>


                        <b-table-column   label="Remark" v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>





                        <b-table-column   label="#" v-slot="props">
                            <b-button type="is-danger" icon-right="delete" @click="deleteLabDiseasecodeRecWithLabID(props.row.ID)" :disabled="!((userRoleFind(4)||userRoleFind(5) )&&dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id)" />
                        </b-table-column>



                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                                icon="emoticon-sad"
                                                size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>
                    </b-table>


               </div>

                </section>









                <footer class="modal-card-foot">
                    <div class="container" style=" width: 100vw; margin-left: 10px;">

                        <nav class="level" style="width:100vw;">
                            <div class="level-left">
                                <div class="level-item">
                                    <b-button type="is-danger"
                                              icon-left="close"  @click="close"   >
                                        Close
                                    </b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-warning" icon-left="cloud-upload"   v-if="userRoleFind(3)&&dataPCRSpecLN.status.id <5"   @click="updateData(3)"  > Save Prepare</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"   v-if="(userRoleFind(4)  )&&dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id "    @click="updateData(4)"  > Save Content to Draft</b-button>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"      v-if="(userRoleFind(4) ) &&dataPCRSpecLN.status.id <5 && dataPCRSpecLN.assigned_to_user.id === user_id "   @click="updateData(5)"  > Save Content to Publish Incomplete</b-button>
                                </div>
                                <div class="level-item">
                                    <b-button type="is-success" icon-left="cloud-upload"     v-if="(userRoleFind(4) ) &&dataPCRSpecLN.status.id <6 && dataPCRSpecLN.assigned_to_user.id === user_id "   @click="updateData(6)"  > Save Content to Publish Complete</b-button>
                                </div>

                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                                <div class="level-item">
                                    &nbsp;
                                </div>
                            </div>
                        </nav>
                    </div>
                </footer>


            </div>

          <SelectPathogen
                  v-if="isSelectPathogenShowing"
                  :isComponentModalActive="isSelectPathogenShowing"
                  @close="closeSelectPathogen"
                  @closeWithSelectItem="closeWithSelectItem"
                  />

          <UploadFiles  v-if="isModalUploadFiles"
                          :idlab=null
                          :plus=false
                          @close="closeAddImageAttach"
                          @closeWithData="closeAddImageAttachWithData"/>

          <SelectDiseaseCode v-if="isModalSelectDiseaseCode"
                               @close="closeSelectDiseaseCode"
                               @closeWithChange="closeSelectDiseaseCode_WithChange" />


        </b-modal>

    </div>



</template>

<script>

    import {   MAX_CHAR_PCR_COMMENT_EACH  ,getBaseURLAvartar ,genUUID , getBaseURLforBackEnd , getConfigAxios , LOCATE_ENDPOINT_UPDATEEACH_KINDLAB }  from '@/utils.js'
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import {mapActions, mapState} from "vuex";
    import HeaderDecorate from "./DecorateComponents/HeaderDecorate";
    import globalconst from "../../mixins/globalconst";
    import SelectPathogen from "./SelectPathogen";
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import UploadFiles from "../UtilsComponents/UploadFiles";
    import SelectDiseaseCode from "./SelectDiseaseCode";
    import axios from "axios";
    import reloadMyJobsTray from "../../mixins/methods/reloadMyJobsTray";
    import htmlToText from "html-to-text";
    import DetailUsedPartFromRequestDataEachLab from "../UtilsComponents/DetailUsedPartFromRequestDataEachLab";


    export default {
        name: "EditDocLabPCR",

        components:{
            HeaderDecorate,
            SelectPathogen,
            ThumbnailImageList,
            UploadFiles,
            SelectDiseaseCode,
            DetailUsedPartFromRequestDataEachLab
        },




        props:{
            isComponentModalActive : Boolean,
            IDLABSelected: null
        },
        computed: {
            ...mapState({
                OPDSelected: state => state.opd_target.opd_selected,
                user_id: state => state.master_data.user_id,
                userIsAdmin: state => state.master_data.userIsAdmin,
                clientIP: state => state.master_data.clientIP,
                user_role: state => state.master_data.user_role,
                dataPCRSpecLN: state => state.pcr.dataPCRSpecLN,
                buffDatPrepareDat: state => state.pcr.buffDatPrepareDat,
                buffDatCtDat: state => state.pcr.buffDatCtDat,
                myTemplate: state => state.mytemplateTxt.myTemplate,
                access_token: state => state.master_data.access_token,
            }),

            getTextFromCtHTML:function () {
                return  htmlToText.fromString(this.buffDatCtDatModel || '', {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },
            getTextFromPrepareHTML:function () {
                return  htmlToText.fromString(this.buffDatPrepareDatModel || '', {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            },
            buffDatCtDatModel :{
                get: function () {
                    return this.buffDatCtDat
                },
                set: function (newValue) {
                    this.produceBuffDatCtDat(newValue)
                }
            },
            buffDatPrepareDatModel :{
                get: function () {
                    return this.buffDatPrepareDat
                },
                set: function (newValue) {
                    this.produceBuffDatPrepareDat(newValue)
                }
            },
            GLOBAL_VAR(){
                return { MAX_CHAR_PCR_COMMENT_EACH }
            },
            findIDInArrOnly: function () {
               return this.dataPCRSpecLN.dataresultset_2.map(dat=>{
                   return dat.idpathogen
               })
            },

            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]
                return this.dataPCRSpecLN.img.dat.map(dat => {
                    // console.log(dat)
                    return   { id: genUUID(5) ,
                        file : null,
                        urlTempUploaded:
                            dat.fresh ? `${getBaseURLAvartar()}/temp/${dat.file}` :   `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                        title : dat.title,
                        fileNameUploaded: dat.file,
                        fresh : false  }

                })
            },

            dataPathogenSpecForVisibleTrue: function(){
                return this.dataPCRSpecLN.dataresultset_2.filter(dat=>{
                  return   dat.visible
                })
            }

        },
        mixins:[userRoleFind,globalconst,reloadMyJobsTray],
        methods:{
            ...mapActions({
                fetchPCROLDDat: 'pcr/fetchPCROLDDat',
                fetchMyJobsTray: 'myjobstray/fetchMyJobsTray',
                produceBuffDatPrepareDat : 'pcr/produceBuffDatPrepareDat',
                produceBuffDatCtDat : 'pcr/produceBuffDatCtDat',
            }),
            // getErrOrNot: function(_id){
            //
            //         const member = this.dataPCRSpecLN.dataresultset_1.idpathogen.find(dat=> dat === _id)
            //         const memberIndex = this.dataPCRSpecLN.dataresultset_1.idpathogen.indexOf(member)
            //
            //         return !this.hasResultInValid[memberIndex].value
            //
            // },
            addTemplate(editorTarget){





                if(editorTarget === "editorDat_ct"){

                    if(this.dataTemplateSelectedCt !== null) {
                        const datToEditor = this.myTemplate.find(member => member.id === this.dataTemplateSelectedCt)

                        this.$refs.editorDat_ct.quill.focus()
                        if (this.$refs.editorDat_ct.quill.getSelection().index !== null) {
                            this.$refs.editorDat_ct.quill.clipboard.dangerouslyPasteHTML(this.$refs.editorDat_ct.quill.getSelection().index, datToEditor.content_html);
                            this.$refs.editorDat_ct.quill.setSelection(this.$refs.editorDat_ct.quill.getSelection().index + datToEditor.content_txt.length)
                        }
                    }else{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `please select some template`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }
                }






                if(editorTarget === "editorDat_prepare"){

                    if(this.dataTemplateSelectedPrepare!== null) {
                        const datToEditor = this.myTemplate.find(member => member.id === this.dataTemplateSelectedPrepare)
                        this.$refs.editorDat_prepare.quill.focus()
                        if(this.$refs.editorDat_prepare.quill.getSelection().index !== null) {
                            this.$refs.editorDat_prepare.quill.clipboard.dangerouslyPasteHTML(this.$refs.editorDat_prepare.quill.getSelection().index,  datToEditor.content_html);
                            this.$refs.editorDat_prepare.quill.setSelection(  this.$refs.editorDat_prepare.quill.getSelection().index + datToEditor.content_txt.length )
                        }
                    }else{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `please select some template`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    }

                }





            },
            closeSelectDiseaseCode_WithChange(dataToSave){
                this.dataPCRSpecLN.diag_code.dat.push(dataToSave)
            },
            closeSelectDiseaseCode(){
                this.isModalSelectDiseaseCode = false
            },
            addNewDiseaseCode(){
                this.isModalSelectDiseaseCode = true
            },
            deleteLabDiseasecodeRecWithLabID(id){
                const member = this.dataPCRSpecLN.diag_code.dat.find( member => member.ID === id)
                const memberIndex = this.dataPCRSpecLN.diag_code.dat.indexOf(member)

                this.dataPCRSpecLN.diag_code.dat.splice(memberIndex,1)

            },
            deleteImage(fileNameUploaded){
                const member = this.dataPCRSpecLN.img.dat.find(member => member.file === fileNameUploaded  )
                const memberIndex = this.dataPCRSpecLN.img.dat.indexOf(member)
                this.dataPCRSpecLN.img.dat.splice(memberIndex,1)
            },
            closeAddImageAttachWithData(dat){
                if(dat.file){

                    const tmp = {
                        "file":   dat.fileNameUploaded,
                        "title":  dat.title,
                        "fresh": true
                    }
                    this.dataPCRSpecLN.img.dat.push(tmp)
                }

                this.isModalUploadFiles = false
            },
            closeAddImageAttach(){
                this.isModalUploadFiles = false
            },
            addImageAttach(){
                this.isModalUploadFiles = true
            },
            // getIDPathogen(){
            //     const  tmpID = getRandomInt()
            //     // console.log(tmpID)
            //     const tmpDat = this.findIDInArrOnly.find(dat=>dat === tmpID)
            //     if(tmpDat!==null){
            //         return tmpID
            //     }else{
            //         this.getIDPathogen()
            //     }
            // },
            closeWithSelectItem(payload){


                // payload as return
                // {"id":1,"title":"Canine Distemper virus  rwerwerwer","idpart":"030080100087","descp_part":"(PCR) Canine distemper virus (CDV) (600)","result_type":2,"result_dat_aval":{"id":["Male","Female"]},"enable":true}



                // "dataresultset_2": [
                //     {
                //         "idpathogen": 2,
                //         "title": "Canine Parvovirus",
                //         "result_dat": null,
                //         "result_aval": [
                //         "Negative",
                //         "Positive"
                //     ],
                //         "comment_each": ""
                //     }
                // ]



                // console.log(JSON.stringify(payload))
                // console.log( payload.result_dat_aval.id)
                const tmpDat = this.dataPCRSpecLN.dataresultset_2.find(dat=>{
                    return (dat.idpathogen === payload.id)&&(dat.visible)
                })

                // console.log(tmpDat)
                if (tmpDat){
                    // console.log('duplicate')
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message:`duplicate  with <b>${tmpDat.title}</b>` ,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }else{
                    // console.log('not duplicate')
                    this.dataPCRSpecLN.dataresultset_2.push( {
                        "idpathogen":  payload.id,
                        "title": payload.title,
                        "result_dat":null,
                        "result_aval": payload.result_dat_aval.id,
                        "comment_each":"",
                        "visible" : true
                    })


                    this.dataPCRSpecLN.dataresultset_1.idpathogen.push( payload.id)
                    this.dataPCRSpecLN.dataresultset_1.title.push( payload.title)
                    this.dataPCRSpecLN.dataresultset_1.result_dat.push(null)
                    this.dataPCRSpecLN.dataresultset_1.result_aval.push(  payload.result_dat_aval.id )
                    this.dataPCRSpecLN.dataresultset_1.visible.push(true)
                    this.dataPCRSpecLN.dataresultset_1.comment_each.push("")


                }










                this.isSelectPathogenShowing = false
            },
            closeSelectPathogen(){
                this.isSelectPathogenShowing = false
            },
            addPathogen(){
                this.isSelectPathogenShowing = true
            },
            deleteItemPathogen(_idToDelete){

                // dataresultset_2
                const member = this.dataPCRSpecLN.dataresultset_2.find(dat=>{
                    return dat.idpathogen === _idToDelete
                })
                const memberIndex = this.dataPCRSpecLN.dataresultset_2.indexOf(member)
                this.dataPCRSpecLN.dataresultset_2.splice(memberIndex,1)

                // dataresultset_1
                const member1 = this.dataPCRSpecLN.dataresultset_1.idpathogen.find(dat=>{
                    return dat === _idToDelete
                })
                // console.log(member1)
                const memberIndex1 = this.dataPCRSpecLN.dataresultset_1.idpathogen.indexOf(member1)
                this.dataPCRSpecLN.dataresultset_1.idpathogen.splice(memberIndex1,1)
                this.dataPCRSpecLN.dataresultset_1.title.splice(memberIndex1,1)
                this.dataPCRSpecLN.dataresultset_1.result_dat.splice(memberIndex1,1)
                this.dataPCRSpecLN.dataresultset_1.result_aval.splice(memberIndex1,1)
                this.dataPCRSpecLN.dataresultset_1.comment_each.splice(memberIndex1,1)



            },
            close(){
               this.$emit('close')
            },


            checkDataValid(){

                for(var i =0;i< this.dataPCRSpecLN.dataresultset_1.idpathogen.length ; i ++){
                    if(this.dataPCRSpecLN.dataresultset_1.result_dat[i]===null){
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'Field Result Require but empty',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        return false
                    }
                }


                 return true

            },
            updateData( idstatus ){
                if (this.isSavingPCR || (this.IDLABSelected.kind || '').toUpperCase() !== 'PCR') return


               if( this.checkDataValid() ) {
                   // console.log('ok pass')


                   // idstatus

                   //  // update ICD10 Code
                   var arrIndex = []
                   var arrID_GRP_ICD10 = []
                   var arrID_ACCURATE = []
                   var arrUnclassifiedCode = []
                   var arrCommentTxt = []
                   //  clear null to empty string
                   for (var j = 0; j < this.dataPCRSpecLN.diag_code.dat.length; j++) {

                       if (this.dataPCRSpecLN.diag_code.dat[j].level5ID === null) {
                           this.dataPCRSpecLN.diag_code.dat[j].level5ID = ""
                       }
                       if (this.dataPCRSpecLN.diag_code.dat[j].level4ID === null) {
                           this.dataPCRSpecLN.diag_code.dat[j].level4ID = ""
                       }
                       if (this.dataPCRSpecLN.diag_code.dat[j].level3ID === null) {
                           this.dataPCRSpecLN.diag_code.dat[j].level3ID = ""
                       }
                       if (this.dataPCRSpecLN.diag_code.dat[j].level2ID === null) {
                           this.dataPCRSpecLN.diag_code.dat[j].level2ID = ""
                       }
                       if (this.dataPCRSpecLN.diag_code.dat[j].level1ID === null) {
                           this.dataPCRSpecLN.diag_code.dat[j].level1ID = ""
                       }


                   }

                   for (var i = 0; i < this.dataPCRSpecLN.diag_code.dat.length; i++) {

                       if (this.dataPCRSpecLN.diag_code.dat[i].level5ID !== "") {
                           arrID_GRP_ICD10.push(this.dataPCRSpecLN.diag_code.dat[i].level5ID)
                       } else if (this.dataPCRSpecLN.diag_code.dat[i].level4ID !== "") {
                           arrID_GRP_ICD10.push(this.dataPCRSpecLN.diag_code.dat[i].level4ID)
                       } else if (this.dataPCRSpecLN.diag_code.dat[i].level3ID !== "") {
                           arrID_GRP_ICD10.push(this.dataPCRSpecLN.diag_code.dat[i].level3ID)
                       } else if (this.dataPCRSpecLN.diag_code.dat[i].level2ID !== "") {
                           arrID_GRP_ICD10.push(this.dataPCRSpecLN.diag_code.dat[i].level2ID)
                       } else if (this.dataPCRSpecLN.diag_code.dat[i].level1ID !== "") {
                           arrID_GRP_ICD10.push(this.dataPCRSpecLN.diag_code.dat[i].level1ID)
                       } else {
                           arrID_GRP_ICD10.push(null)
                       }


                       arrIndex.push(this.dataPCRSpecLN.diag_code.dat[i].ID)
                       arrID_ACCURATE.push(this.dataPCRSpecLN.diag_code.dat[i].labDiseasecodeAccurateID)
                       arrUnclassifiedCode.push(this.dataPCRSpecLN.diag_code.dat[i].unClassifiedCodes)
                       arrCommentTxt.push(this.dataPCRSpecLN.diag_code.dat[i].comment)
                   }


                   //******************************************************************************************************
                   var arrImage = []
                   for (var k = 0; k < this.dataPCRSpecLN.img.dat.length; k++) {
                       arrImage.push({
                           "file": this.dataPCRSpecLN.img.dat[k].file,
                           "title": this.dataPCRSpecLN.img.dat[k].title,
                           "fresh": this.dataPCRSpecLN.img.dat[k].fresh
                       })
                   }


                   // console.log(this.dataPCRSpecLN.dataresultset_1.result_dat)
                   var arr_idpathogen = []
                   var arr_result_dat = []
                   var arr_comment_each = []
                   for(var l =0 ; l < this.dataPCRSpecLN.dataresultset_1.idpathogen.length; l++){
                      if (this.dataPCRSpecLN.dataresultset_1.visible[l]) {
                          arr_idpathogen.push(this.dataPCRSpecLN.dataresultset_1.idpathogen[l])
                          arr_result_dat.push( this.dataPCRSpecLN.dataresultset_1.result_dat[l] )
                          arr_comment_each.push(this.dataPCRSpecLN.dataresultset_1.comment_each[l])
                      }
                   }
                   const submittedPrepare = this.buffDatPrepareDat
                   const submittedCt = this.buffDatCtDat
                   const submittedResults = JSON.stringify(this.dataPCRSpecLN.dataresultset_2)
                   const encodeText = value => value == null ? null : Buffer.from(value, 'utf8').toString('base64')
                   const datTo = {
                       "ln": this.IDLABSelected.idlab,
                       "ip": this.clientIP,
                       "status": idstatus,
                       "data": {
                           "dat_prepare": encodeText(submittedPrepare),
                           "dat_prepare_txt": submittedPrepare == null ? null : encodeText(this.getTextFromPrepareHTML),
                           "dat_ct": encodeText(submittedCt),
                           "dat_ct_txt": submittedCt == null ? null : encodeText(this.getTextFromCtHTML),
                           "idpathogen": arr_idpathogen,
                           "result_dat": arr_result_dat,
                           "comment_each": arr_comment_each,

                           "lab_diseasecode_labid": {
                               "arrindex": arrIndex,
                               "arrid_grp_icd10": arrID_GRP_ICD10,
                               "arrid_accurate": arrID_ACCURATE,
                               "arrunclassifiedcode": arrUnclassifiedCode,
                               "arrcommenttxt": arrCommentTxt
                           },
                           "lab_img_path": arrImage
                       }
                   }


                   //
                   // console.log(JSON.stringify(datTo))
                   const vm = this
                   this.isSavingPCR = true
                   this.isFullScreenSearching = true
                   if ((this.IDLABSelected.kind).toUpperCase() === "PCR") {
                       axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                       axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_UPDATEEACH_KINDLAB.PCR}`, datTo, getConfigAxios())
                            .then(async (res) => {
                                const body = res.data || {}
                                const reference = body.request_id || ''
                                const saved = body.saved_text || {}
                                const changedWhileSaving = vm.buffDatPrepareDat !== submittedPrepare ||
                                    vm.buffDatCtDat !== submittedCt ||
                                    JSON.stringify(vm.dataPCRSpecLN.dataresultset_2) !== submittedResults
                                // Everything below is post-commit; do not turn refresh errors into save errors.
                                try {
                                    vm.dataPCRSpecLN.status.id = idstatus
                                    if (Object.prototype.hasOwnProperty.call(saved, 'dat_prepare') && vm.buffDatPrepareDat === submittedPrepare) {
                                        await vm.produceBuffDatPrepareDat(saved.dat_prepare)
                                    }
                                    if (Object.prototype.hasOwnProperty.call(saved, 'dat_ct') && vm.buffDatCtDat === submittedCt) {
                                        await vm.produceBuffDatCtDat(saved.dat_ct)
                                    }
                                    for (const row of (body.saved_results || [])) {
                                        const index = arr_idpathogen.findIndex(id => String(id) === String(row.idpathogen))
                                        if (index < 0) continue
                                        for (const current of vm.dataPCRSpecLN.dataresultset_2) {
                                            if (String(current.idpathogen) === String(row.idpathogen) && current.comment_each === arr_comment_each[index]) {
                                                current.comment_each = row.comment_each == null ? '' : row.comment_each
                                            }
                                        }
                                    }
                                    const refreshes = [2, 3, 4, 5].map(status =>
                                        Promise.resolve().then(() => vm.fetchMyJobsTray({user_id: vm.user_id, status_id: status})))
                                    if (!changedWhileSaving) {
                                        refreshes.push(Promise.resolve().then(() => vm.fetchPCROLDDat({ln: datTo.ln, ip: datTo.ip})))
                                    }
                                    const failures = await Promise.all(refreshes.map(task => task.then(() => false, () => true)))
                                    const warning = failures.some(Boolean) || changedWhileSaving || (body.warnings && body.warnings.length)
                                    vm.$buefy.toast.open({
                                        message: warning
                                            ? `บันทึกสำเร็จ แต่ยังโหลดข้อมูลล่าสุดไม่ครบหรือมีข้อมูลแก้ไขเพิ่ม กรุณาตรวจสอบก่อนบันทึกซ้ำ (รหัสอ้างอิง: ${reference})`
                                            : 'Update data completely!',
                                        type: warning ? 'is-warning' : 'is-success'
                                    })
                                } catch (refreshError) {
                                    vm.$buefy.toast.open({
                                        message: `บันทึกสำเร็จ แต่แสดงผลล่าสุดไม่สำเร็จ กรุณาเปิดผลตรวจใหม่ก่อนบันทึกซ้ำ (รหัสอ้างอิง: ${reference})`,
                                        type: 'is-warning'
                                    })
                                }
                            })
                        .catch(err=>{
                            const result = (err.response && err.response.data) || {}
                            const messages = {
                                invalid_input: 'ข้อมูลที่ส่งไม่ถูกต้อง กรุณาตรวจสอบช่องที่ระบุ',
                                invalid_base64: 'รูปแบบข้อความไม่ถูกต้อง กรุณาเปิดผลตรวจใหม่',
                                invalid_pathogen: 'ไม่พบรายการเชื้อที่เลือก กรุณาตรวจสอบรายการ',
                                invalid_result: 'ผลตรวจไม่ตรงกับตัวเลือกที่อนุญาต กรุณาเลือกใหม่',
                                text_too_long: 'ข้อความยาวเกินขนาดที่รองรับหลังแปลงอักขระ กรุณาตรวจสอบช่องที่ระบุ',
                                unsupported_characters: 'มีอักขระที่ฐานข้อมูลไม่รองรับ กรุณาตรวจสอบช่องที่ระบุ',
                                image_missing: 'ไม่พบไฟล์รูปชั่วคราว กรุณาอัปโหลดรูปใหม่',
                                image_conflict: 'ชื่อไฟล์รูปซ้ำกับไฟล์เดิมที่มีเนื้อหาต่างกัน กรุณาอัปโหลดใหม่',
                                status_conflict: 'ข้อมูลสถานะผลตรวจไม่สอดคล้อง กรุณาเปิดผลตรวจใหม่',
                                not_found: 'ไม่พบรายการตรวจ PCR นี้',
                                save_outcome_unknown: 'ยังยืนยันผลการบันทึกไม่ได้ กรุณาเปิดผลตรวจใหม่เพื่อตรวจสอบก่อนบันทึกซ้ำ',
                                save_failed: 'บันทึกไม่สำเร็จ กรุณาแจ้งรหัสอ้างอิงให้ผู้ดูแลตรวจสอบ'
                            }
                            const message = messages[result.code] || (err.response
                                ? 'บันทึกไม่สำเร็จ กรุณาตรวจสอบการเข้าสู่ระบบหรือแจ้งผู้ดูแล'
                                : 'ไม่ได้รับคำตอบจากระบบ กรุณาเปิดผลตรวจใหม่เพื่อตรวจสอบก่อนบันทึกซ้ำ')
                            // Buefy renders dialog messages as HTML; escape server fields.
                            const escapeHtml = value => String(value).replace(/[&<>"']/g, char => ({
                                '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
                            }[char]))
                            const characters = Array.isArray(result.unsupported_characters)
                                ? result.unsupported_characters.slice(0, 12)
                                    .map(item => `${item.character} (${item.codepoint})`).join(', ')
                                : ''
                            const characterHint = characters ? ` อักขระที่ไม่รองรับ: ${characters}` : ''
                            const field = result.field ? ` ช่อง: ${result.field}` : ''
                            const reference = result.request_id ? ` รหัสอ้างอิง: ${result.request_id}` : ''
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: escapeHtml(message + field + characterHint + reference),
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })


                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                        })
                        .finally(()=>{
                            vm.isFullScreenSearching = false
                            vm.isSavingPCR = false
                        })

                   }


               }

            },
            loadOldDat(){
                this.isFullScreenSearching = true
                return this.fetchPCROLDDat({ln: this.IDLABSelected.idlab, ip: this.clientIP})
                    .catch(err => {
                        this.$buefy.dialog.alert({title: 'Error', message: 'โหลดผล PCR ไม่สำเร็จ กรุณาลองเปิดผลตรวจใหม่', type: 'is-danger'})
                        if (err.response && err.response.status === 401) this.$router.push('/login')
                    })
                    .finally(() => { this.isFullScreenSearching = false })
            }

        },
        data(){
            return {
                // isComponentModalActive : false,
                isFullScreenSearching : false,
                isSavingPCR: false,
                isFullScreen : true,
                isEmpty : false,
                // dataPCRSpecLN : Object.assign( {} ,DATA_PCR_LN_MODEL) ,  // used into state not local !!!!

                // pass into props
                isSelectPathogenShowing : false,
                isModalUploadFiles : false,
                isModalSelectDiseaseCode : false,


                dataTemplateSelectedCt : null,
                dataTemplateSelectedPrepare : null,


                modeThumbnailImageList : "edit",
                customToolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    // ["image", "code-block"],
                    [ "code-block"],
                    [{ 'color': [] }, { 'background': [] }],
                    ['link'],
                ],

            }
        },
        watch:{
            'dataPCRSpecLN.dataresultset_2':{
                deep : true,
                handler: function (val) {
                            this.dataPCRSpecLN.dataresultset_1.idpathogen = []
                            this.dataPCRSpecLN.dataresultset_1.title = []
                            this.dataPCRSpecLN.dataresultset_1.result_dat = []
                            this.dataPCRSpecLN.dataresultset_1.result_aval = []
                            this.dataPCRSpecLN.dataresultset_1.comment_each = []
                            this.dataPCRSpecLN.dataresultset_1.user_rec_id = []
                            this.dataPCRSpecLN.dataresultset_1.user_rec_fn = []
                            this.dataPCRSpecLN.dataresultset_1.datetime_rec = []
                            // update dataresultset_1 and hasResultInValid Array


                            val.forEach(dat=>{
                                this.dataPCRSpecLN.dataresultset_1.idpathogen.push(dat.idpathogen)
                                this.dataPCRSpecLN.dataresultset_1.title.push(dat.title)
                                this.dataPCRSpecLN.dataresultset_1.result_dat.push(dat.result_dat)
                                this.dataPCRSpecLN.dataresultset_1.result_aval.push({
                                                                                     "id":  dat.result_aval
                                                                                     })
                                this.dataPCRSpecLN.dataresultset_1.comment_each.push(dat.comment_each)
                                this.dataPCRSpecLN.dataresultset_1.user_rec_id.push(dat.user_rec_id)
                                this.dataPCRSpecLN.dataresultset_1.user_rec_fn.push(dat.user_rec_fn)
                                this.dataPCRSpecLN.dataresultset_1.datetime_rec.push(dat.datetime_rec)
                            })


                }
            },
            isComponentModalActive :{
                immediate : true,
                handler: function (val) {

                    if(val){
                        this.loadOldDat()
                    }


                }
            },

        }
    }
</script>

<style scoped>

</style>
